import { render, staticRenderFns } from "./AccountDetail.vue?vue&type=template&id=4b3a50bc&scoped=true&"
import script from "./AccountDetail.vue?vue&type=script&lang=js&"
export * from "./AccountDetail.vue?vue&type=script&lang=js&"
import style0 from "./AccountDetail.vue?vue&type=style&index=0&id=4b3a50bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3a50bc",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/AccountDetail.vue
// module id = null
// module chunks = 